import { useState } from 'react';

const faqs = [
  {
    question: 'What is LitBuy Spreadsheet?',
    answer: 'LitBuy Spreadsheet is a powerful deal tracking and price comparison tool designed for modern shoppers. It helps you organize, track, and compare products across categories like Shoes, Hoodies, T-Shirts, Jackets, and more — all within a single intuitive spreadsheet interface.',
  },
  {
    question: 'How do I get started with LitBuy Spreadsheet?',
    answer: 'Getting started with LitBuy Spreadsheet is simple. Visit our complete guide where we walk you through setup, template selection, data entry, and how to start tracking deals across all 14 product categories. The entire setup process takes less than 5 minutes.',
  },
  {
    question: 'Is LitBuy Spreadsheet free to use?',
    answer: 'LitBuy Spreadsheet templates and guides are available for free through our resource hub. For the complete shopping experience and access to all product categories including Shoes, Bags, Accessories, and more, visit KASpreadsheet.com to explore pricing options.',
  },
  {
    question: 'What categories does LitBuy Spreadsheet support?',
    answer: 'LitBuy Spreadsheet supports deal tracking across 14 product categories: Shoes, Hoodies/Sweaters, T-Shirts, Jackets, Pants/Shorts, Headwear, Sets, Underwear/Underpants, Jersey, Accessories, Bags, Belts, Perfumes, and OtherStuff — giving you comprehensive coverage for all your shopping needs.',
  },
  {
    question: 'Can I use LitBuy Spreadsheet on mobile devices?',
    answer: 'Yes! LitBuy Spreadsheet is designed to work seamlessly across desktop and mobile devices. You can track deals, compare prices, and browse categories on the go, ensuring you never miss a great deal no matter where you are.',
  },
  {
    question: 'How does LitBuy Spreadsheet compare to other tools?',
    answer: 'Compared to manual tracking methods or generic tools like Google Sheets, LitBuy Spreadsheet offers purpose-built templates, automated deal tracking, built-in price comparison charts, and support for 14 curated shopping categories — making it far more efficient and user-friendly for serious shoppers.',
  },
];

export default function HomeFAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block text-xs font-semibold tracking-widest uppercase text-primary-500 mb-4">FAQ</span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 leading-tight">
            Frequently Asked Questions
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-[480px] mx-auto">
            Everything you need to know about LitBuy Spreadsheet and how it helps you shop smarter
          </p>
        </div>

        <div className="max-w-[720px] mx-auto flex flex-col gap-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="rounded-xl bg-background-50 border border-background-200/60 overflow-hidden"
            >
              <button
                onClick={() => toggleFaq(index)}
                className="w-full flex items-center justify-between p-5 text-left cursor-pointer group"
              >
                <span className="text-sm md:text-base font-semibold text-foreground-900 pr-4">
                  {faq.question}
                </span>
                <span className={`w-7 h-7 flex items-center justify-center rounded-full flex-shrink-0 transition-all duration-300 ${openIndex === index ? 'bg-primary-500 text-background-50 rotate-45' : 'bg-background-100 text-foreground-500 group-hover:bg-primary-100 group-hover:text-primary-500'}`}>
                  <i className="ri-add-line text-sm"></i>
                </span>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${openIndex === index ? 'max-h-[300px] opacity-100' : 'max-h-0 opacity-0'}`}
              >
                <p className="px-5 pb-5 text-sm text-foreground-600 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* FAQ Schema */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: faqs.map((faq) => ({
              '@type': 'Question',
              name: faq.question,
              acceptedAnswer: {
                '@type': 'Answer',
                text: faq.answer,
              },
            })),
          }),
        }}
      />
    </section>
  );
}